import { createContext } from 'react';

import { CategoricalBarChartLegendConfiguration } from '../types/categorical-bar-chart.js';
import { DEFAULT_LEGEND } from '../types/defaults.js';

export const CategoricalBarChartLegendContext =
  createContext<CategoricalBarChartLegendConfiguration>(DEFAULT_LEGEND);

CategoricalBarChartLegendContext['displayName'] =
  'CategoricalBarChartLegendContext';
